import httpClientNewsletter from '../api/httpClientNewsletter';

export const getAllNewsletters = async ({ pageNumber = 1, pageSize = 10 } = {}) => {
  const response = await httpClientNewsletter.get('/api/cms/NewsletterManagement/GetAll', {
    params: { pageNumber, pageSize },
  });
  return response.data;
};

export const createNewsletter = async ({ title, isActive = true, isPublished = false, publishedAtUtc = null }) => {
  const body = {
    title,
    isActive,
    isPublished,
    publishedAtUtc: publishedAtUtc || null,
  };
  const response = await httpClientNewsletter.post('/api/cms/NewsletterManagement/Create', body);
  return response.data;
};

export const updateNewsletter = async ({ id, title, order, isActive, isPublished, publishedAtUtc }) => {
  const body = {
    id,
    title,
    order,
    isActive,
    isPublished,
    publishedAtUtc: publishedAtUtc || null,
  };
  const response = await httpClientNewsletter.put('/api/cms/NewsletterManagement/Update', body);
  return response.data;
};

export const deleteNewsletter = async (id) => {
  const response = await httpClientNewsletter.delete(`/api/cms/NewsletterManagement/Delete/${id}`);
  return response.data;
};

export const getNewsletterById = async (id) => {
  const response = await httpClientNewsletter.get(`/api/cms/NewsletterManagement/GetById/${id}`);
  return response.data;
};

export const reorderNewsletters = async ({ newsletterIdsInOrder }) => {
  const response = await httpClientNewsletter.post('/api/cms/NewsletterManagement/Reorder', {
    newsletterIdsInOrder,
  });
  return response.data;
};

export const publishNewsletter = async ({ id, isPublished }) => {
  const response = await httpClientNewsletter.post(`/api/cms/NewsletterManagement/Publish/${id}`, {
    id,
    isPublished,
  });
  return response.data;
};

export const uploadNewsletterCoverImage = async ({ newsletterId, file }) => {
  const formData = new FormData();
  if (newsletterId) formData.append('NewsletterId', newsletterId);
  if (file instanceof File) formData.append('CoverImage', file, file.name);
  const response = await httpClientNewsletter.post('/api/cms/NewsletterManagement/UploadCoverImage', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadNewsletterPdf = async ({ newsletterId, file }) => {
  const formData = new FormData();
  if (newsletterId) formData.append('NewsletterId', newsletterId);
  if (file instanceof File) formData.append('PdfFile', file, file.name);
  const response = await httpClientNewsletter.post('/api/cms/NewsletterManagement/UploadPdf', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export default {
  getAllNewsletters,
  createNewsletter,
  updateNewsletter,
  deleteNewsletter,
  getNewsletterById,
  reorderNewsletters,
  publishNewsletter,
  uploadNewsletterCoverImage,
  uploadNewsletterPdf,
};
